@use "../../sass/global/global" as *;

$white-rgba: rgba(255, 255, 255, 1) 100%;
$black-rgba: rgba(255, 255, 255, 0) 0%;

.ux-iws-search-preview {
    display: block;

    &--active {
        box-shadow: 0 7px 22px rgba(19, 19, 19, 0.08);
        background: $color-white;
        z-index: 300;
    }

    &__category {
        margin-top: $dim-10;

        a {
            font-size: $size-text-small;
        }
    }

    &__category-list {
        border-top: 1px solid $color-gray-borders;
        margin-bottom: $dim-30;

        @include legacy-gridle-state(tdlarge) {
            margin-right: $dim-15;
        }
    }

    &__element {
        padding: 15px;

        &--headline {
            padding-bottom: 0;
            padding-top: 0;
        }
    }

    &__element-headline {
        text-decoration: none;
    }

    &__element-content {
        align-items: center;
        display: flex !important;
    }

    &__faded {
        height: 50px;
        position: sticky;
        bottom: 0;
        background: linear-gradient(to bottom, $black-rgba, $white-rgba);
    }

    &__items-headline {
        .text-tiny {
            border-bottom: 1px solid $color-gray-borders;
            padding-bottom: 6px;
        }
    }

    &__section {
        margin-bottom: 30px;

        &--article-tiles {
            max-height: 600px;
            overflow-y: auto;
        }

        &--article-tiles h3 {
            margin: 0;
        }
    }

    &__show-more {
        text-align: center;
        margin-top: $dim-15;
        margin-bottom: $dim-10;

        @include legacy-gridle-state(t) {
            margin-bottom: $dim-30;
        }
    }

    &__show-all {
        display: flex;
        justify-content: center;
    }

    .ux-dropdown__label {
        padding: 9px 25px;
    }

    .ux-iws-search-bar__inner {
        min-width: none;
        padding: 0;

        @media (min-width: $gridle-t-min) {
            display: flex;
        }
    }

    .ux-iws-search-bar__controls {
        max-width: 100%;
        padding: 0;
        width: 100%;
    }
}
